import Vue from "vue";
import Vuex from "vuex";

export default class {
  constructor() {
    Vue.use(Vuex);
    const state = {
      config: null,
      results: null,
      loading: true,
      noResults: false,
      noResultsMessage: "",
      errorMessage: "",
      error: false
    };
    const getters = {
      config: state => state.config,
      results: state => state.results,
      loading: state => state.loading,
      error: state => state.error,
      errorMessage: state => state.errorMessage,
      noResults: state => state.noResults,
      noResultsMessage: state => state.noResultsMessage
    };
    const actions = {
      async loadConfig(
        { commit },
        { url, nodeAlias, error, noResultsMessage }
      ) {
        commit("setStateValue", { key: "errorMessage", value: error });
        commit("setStateValue", {
          key: "noResultsMessage",
          value: noResultsMessage
        });
        await fetch(
          `${url}?${new URLSearchParams({
            nodeAlias: nodeAlias
          }).toString()}`
        )
          .then(res => {
            if (!res.ok) {
              commit("setStateValue", { key: "error", value: true });
            }
            return res.json();
          })
          .then(data => {
            commit("setStateValue", { key: "config", value: data });
            commit("setStateValue", { key: "loading", value: false });
          })
          .catch(err => {
            console.error(err);
            commit("setStateValue", { key: "error", value: true });
          });
      },
      async getResults({ commit, state }, { url: url_base, payload, cb }) {
        const params = new URLSearchParams(payload);
        const url = `${url_base}?${params.toString()}`;
        commit("setStateValue", { key: "noResults", value: false });

        await fetch(url)
          .then(res => {
            if (res.status === 204) {
              commit("setStateValue", { key: "noResults", value: true });
            }
            return res.json();
          })
          .then(data => {
            if (state.noResults) return;
            commit("setStateValue", { key: "results", value: data });
            if (cb) cb(true);
          })
          .catch(err => {
            if (state.noResults) return;
            if (cb) cb(false);
            commit("setStateValue", { key: "error", value: true });
          });
      },
      clearResults({ commit }) {
        commit("setStateValue", { key: "results", value: null });
      }
    };

    const mutations = {
      setStateValue(state, payload) {
        state[payload.key] = payload.value;
      }
    };

    this.store = new Vuex.Store({
      state,
      getters,
      mutations,
      actions
    });
  }
}
